<edgvr-front-ui-notifications
  [notifications]="notifications$ | async | defaultTo: []"
  (closeNotification)="onCloseNotification($event)"
></edgvr-front-ui-notifications>
